import React from 'react'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import { localizeCurrency } from '../functions'
import style from './PromoStrip.module.scss'

const PromoStrip = ({ priceMask }: { priceMask: string }) => {
  const { t } = useSurveyLocale()
  return (
    <div className={style.promoStrip}>
      <span
        className={style.text}
        dangerouslySetInnerHTML={{ __html: localizeCurrency(t('questions', 'ec', 'chewy', 'promoStrip'), priceMask) }}
      />
    </div>
  )
}

export default PromoStrip
